module.exports = __webpack_public_path__ + "static/media/drinkPlaceholder.88d190f2.png";